import Cookies from 'js-cookie';
import { IS_VKT_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

export function initMyTeam() {
    const hasMyTeamCookie = !!Cookies.get('isMyTeam');

    if (IS_VKT_WEBVIEW && !hasMyTeamCookie) {
        Cookies.set('isMyTeam', 'true');
    }
}
